import { createFileRoute } from "@tanstack/react-router";
import { ScrollableContainer } from "@/components/ui/scrollbar";
import { Rooms } from "@/components/rooms";
import { useTranslation } from "react-i18next";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";

export const Route = createFileRoute("/(protected)/logistic/rooms/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <ScrollableContainer>
      <div className="flex h-full flex-col">
        <MobilePageTitle className="mt-6 mb-4">
          {t("pages:dashboard.sidebar.rooms")}
        </MobilePageTitle>
        <Rooms />
      </div>
    </ScrollableContainer>
  );
}
